module.exports = __webpack_public_path__ + "static/sorrowful_2-3b9cb54ac15254782a38358921473ae2.jpg";